// config.js - API Configuration
const API_BASE_URL = process.env.NODE_ENV === 'production' 
    ? '' // In production, API calls will be relative to the same domain
    : 'http://localhost:3000';

export const API_ENDPOINTS = {
    LOGIN: `${API_BASE_URL}/api/login`,
    REGISTER: `${API_BASE_URL}/api/register`,
    GOOGLE_LOGIN: `${API_BASE_URL}/api/google-login`,

    VALIDATE_SESSION: `${API_BASE_URL}/api/validate-session`,
    USER_PROFILE: `${API_BASE_URL}/api/user-profile`,
    DATA: `${API_BASE_URL}/api/data`,
    TOPICS: `${API_BASE_URL}/api/topics`,
    TOPICS_REORDER: `${API_BASE_URL}/api/topics/reorder`,
    TIPS: `${API_BASE_URL}/api/tips`,
    CHAT_START: `${API_BASE_URL}/api/chat/start`,
    CHAT: `${API_BASE_URL}/api/chat`,
    TOPIC_FAVORITE: (id) => `${API_BASE_URL}/api/topics/${id}/favorite`,
    TIP_FAVORITE: (id) => `${API_BASE_URL}/api/tips/${id}/favorite`,
    TIP_REVIEW_SCHEDULE: (id) => `${API_BASE_URL}/api/tips/${id}/review-schedule`,
    TIP_REVIEW_STATE: (id) => `${API_BASE_URL}/api/tips/${id}/review-state`,
    TIP_CLEAR_REVIEW_DUE: (id) => `${API_BASE_URL}/api/tips/${id}/clear-review-due`,
    TIP_RESET_REVIEW: (id) => `${API_BASE_URL}/api/tips/${id}/reset-review`,
    LEARNING_SUMMARY: (id) => `${API_BASE_URL}/api/topics/${id}/learning-summary`,
    TOPIC_GROUPS: `${API_BASE_URL}/api/topic-groups`,
    TOPIC_GROUP: (id) => `${API_BASE_URL}/api/topic-groups/${id}`,
    TOPIC_GROUPS_REORDER: `${API_BASE_URL}/api/topic-groups/reorder`,
    TOPIC_ASSIGN_GROUP: (id) => `${API_BASE_URL}/api/topics/${id}/group`,
};

// Review schedule intervals (in days) - Mirrored from backend
export const REVIEW_SCHEDULE = [1, 3, 7, 14, 30, 60]; 